import Vue from 'vue'
import VueMask from 'v-mask'
import ScrollTrigger from 'gsap/ScrollTrigger'

import * as components from './components/index'
import filtersMixin from './mixins/filters'
import apartmentsMixin from './mixins/apartments'
import calculatorMixin from './mixins/calculator'
import getInTouchMixin from './mixins/getInTouch'
import offersMixin from './mixins/offers'
import scrollTo from '../js/common/scroll-to'

Vue.use(VueMask)

const initVueApp = () => {
  const mixins = [calculatorMixin, getInTouchMixin, offersMixin]

  if (document.querySelector('.js-filters')) {
    mixins.push(filtersMixin)
  }
  if (document.querySelector('.js-apartments')) {
    mixins.push(apartmentsMixin)
  }
  new Vue({
    el: document.getElementById('vue-root'),
    components: { ...components },
    mixins,
    methods: {
      scrollTop() {
        scrollTo('.offers-section')
      },
    },
    mounted() {
      const pinTrack = document.querySelector('[data-pin-track]')
      const pin = document.querySelector('[data-pin]')

      if (pinTrack && pin) {
        const trigger = ScrollTrigger.create({
          trigger: pinTrack,
          pin,
          start: 'top 120px',
          end: 'bottom 100%',
        })
      }
    },
  })
}

export default initVueApp
